import { gql } from '@apollo/client'

export const PURCHASE_TICKETS = gql`
  mutation PurchaseTickets(
    $input: PurchaseTicketsInput!
    $donation: DonationInput
  ) {
    purchaseTickets(input: $input, donation: $donation) {
      checkoutUrl
      checkoutClientSecret
      checkoutSessionId
      checkoutStripeAccountId
      checkoutPresentation
      paymentProcessor
      paymentStatus
      orderId
      user
      userAlreadyExist
    }
  }
`
